// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type QueryTagOverviewQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  databaseId: Types.Scalars["ID"]["input"];
}>;

export type QueryTagOverviewQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationDetails?: {
    __typename?: "Organization";
    id: string;
    githubRepository?: string | null;
    githubBranch?: string | null;
  } | null;
  getServerDetails: { __typename?: "Server"; id: string; humanId: string };
};

export const QueryTagOverviewDocument = gql`
  query QueryTagOverview($organizationSlug: ID!, $databaseId: ID!) {
    getOrganizationDetails(organizationSlug: $organizationSlug) {
      id
      githubRepository
      githubBranch
    }
    getServerDetails(databaseId: $databaseId) {
      id
      humanId
    }
  }
`;

/**
 * __useQueryTagOverviewQuery__
 *
 * To run a query within a React component, call `useQueryTagOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryTagOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryTagOverviewQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useQueryTagOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryTagOverviewQuery,
    QueryTagOverviewQueryVariables
  > &
    (
      | { variables: QueryTagOverviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<QueryTagOverviewQuery, QueryTagOverviewQueryVariables>(
    QueryTagOverviewDocument,
    options,
  );
}
export function useQueryTagOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryTagOverviewQuery,
    QueryTagOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QueryTagOverviewQuery,
    QueryTagOverviewQueryVariables
  >(QueryTagOverviewDocument, options);
}
// @ts-ignore
export function useQueryTagOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryTagOverviewQuery,
    QueryTagOverviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  QueryTagOverviewQuery,
  QueryTagOverviewQueryVariables
>;
export function useQueryTagOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryTagOverviewQuery,
        QueryTagOverviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryTagOverviewQuery | undefined,
  QueryTagOverviewQueryVariables
>;
export function useQueryTagOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryTagOverviewQuery,
        QueryTagOverviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    QueryTagOverviewQuery,
    QueryTagOverviewQueryVariables
  >(QueryTagOverviewDocument, options);
}
export type QueryTagOverviewQueryHookResult = ReturnType<
  typeof useQueryTagOverviewQuery
>;
export type QueryTagOverviewLazyQueryHookResult = ReturnType<
  typeof useQueryTagOverviewLazyQuery
>;
export type QueryTagOverviewSuspenseQueryHookResult = ReturnType<
  typeof useQueryTagOverviewSuspenseQuery
>;
export type QueryTagOverviewQueryResult = Apollo.QueryResult<
  QueryTagOverviewQuery,
  QueryTagOverviewQueryVariables
>;
